import React from 'react';
import { asCurrency } from '@ally/aos-utils';
import { Description } from '../shared';
var FeeDisplay = function (_a) {
    var fee = _a.fee;
    return React.createElement(Description, { term: "Fee", details: asCurrency(fee) });
};
export default FeeDisplay;
//# sourceMappingURL=Display.js.map